import { render, staticRenderFns } from "./VehicleDashboard.vue?vue&type=template&id=07a0b5ea&scoped=true"
import script from "./VehicleDashboard.vue?vue&type=script&lang=js"
export * from "./VehicleDashboard.vue?vue&type=script&lang=js"
import style0 from "./VehicleDashboard.vue?vue&type=style&index=0&id=07a0b5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0b5ea",
  null
  
)

export default component.exports